import { InviteCode } from '@root/entities/referral'

import type { OAuthState } from '@root/entities/auth'

const TMA_PREFIX = 'google_'

export const parseAccessToken = (startParam: string): string | undefined => {
  const isGoogle = startParam.includes(TMA_PREFIX)
  const param = startParam.replace(TMA_PREFIX, '').trim()

  if (!param || !isGoogle) {
    return undefined
  }

  try {
    return hexToString(param)
  } catch {
    return undefined
  }
}

function hexToString(hex: string): string {
  // Ensure the hex string is valid
  if (hex.length % 2 !== 0) {
    throw new Error('Invalid hex string. Length must be even.')
  }

  // Convert the hex string into a Uint8Array
  const bytes = new Uint8Array(
    hex.match(/.{1,2}/g)!.map((byte) => parseInt(byte, 16)),
  )

  // Decode the Uint8Array into a string using TextDecoder
  const decoder = new TextDecoder('utf-8')
  return decoder.decode(bytes)
}

export type GoogleAuthAction = 'login' | 'register' | 'assign'
const GOOGLE_AUTH_ACTIONS = new Set<GoogleAuthAction>([
  'login',
  'register',
  'assign',
])

const refineGoogleAuthAction = (str: string): str is GoogleAuthAction =>
  GOOGLE_AUTH_ACTIONS.has(str)

export const parseGoogleAuthAction = (
  state: OAuthState,
): {
  action: GoogleAuthAction | undefined
  referralCode: InviteCode | undefined
} => {
  try {
    const decoded = window.atob(state)
    const payload = JSON.parse(decoded) as {
      action: string
      referralCode?: string
    }

    return {
      action: refineGoogleAuthAction(payload.action)
        ? payload.action
        : undefined,
      referralCode: payload.referralCode
        ? InviteCode(payload.referralCode)
        : undefined,
    }
  } catch {
    return { action: undefined, referralCode: undefined }
  }
}
